import SvgIcon from "@mui/material/SvgIcon";

interface CowIconIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function CowIconIcon({ htmlColor, fontSize }: CowIconIconProps) {
  return (
    <SvgIcon
      viewBox="0 0 23 16"
      width="46"
      height="32"
      fontSize={fontSize || "large"}
      sx={{ verticalAlign: "middle" }}
    >
      <path
        d="M7.6466 14.5604L7.84607 14.1947L8.40499 14.4431V14.8778C8.40499 14.8778 8.14764 14.9178 7.99097 14.8778C7.88442 14.8506 7.75891 14.7697 7.67884 14.7121C7.63065 14.6774 7.61817 14.6125 7.6466 14.5604Z"
        fill="#A48137"
      />
      <path
        d="M7.74233 10.096C6.43815 9.08172 5.87923 8.7918 5.42383 7.92243C5.42378 7.92233 7.85693 7.89887 8.83948 8.87467C10.3508 10.3757 8.48754 14.4433 8.48754 14.4433L7.84583 14.1948C7.84583 14.1948 8.10069 13.4091 8.09424 12.8906C8.08819 12.4039 7.91427 12.1512 7.84583 11.6693C7.75925 11.0597 7.88286 10.2053 7.74233 10.096Z"
        fill="#EFC52E"
      />
      <path
        d="M8.10743 14.6318L8.15683 14.319C8.15683 14.319 8.42594 14.4528 8.61225 14.4639C8.81009 14.4756 9.10907 14.3604 9.10907 14.3604V14.7313C9.10907 14.7823 9.07797 14.8281 9.02955 14.8441C8.92712 14.878 8.74633 14.9292 8.61225 14.9193C8.45993 14.9081 8.26659 14.8107 8.16477 14.7536C8.12163 14.7294 8.09972 14.6807 8.10743 14.6318Z"
        fill="#A48137"
      />
      <path
        d="M20.9911 11.3795C20.956 11.0499 21.1774 10.5515 21.1774 10.5515H21.55C21.55 10.5515 21.6433 11.0189 21.6121 11.3174C21.5767 11.6556 21.4465 12.1454 21.343 12.1454C21.2395 12.1454 21.0258 11.7068 20.9911 11.3795Z"
        fill="#A48137"
      />
      <path
        d="M21.1777 10.5721H21.5504C21.5504 10.5721 21.6539 8.7553 21.6539 7.59118C21.6539 6.42705 21.5089 4.44464 21.5089 4.44464L21.1777 10.5721Z"
        fill="#FDFBEB"
      />
      <path
        d="M17.8032 14.3603H17.0165C17.0165 14.3603 17.2344 12.4054 17.0579 11.2138C16.899 10.1406 16.292 8.54336 16.292 8.54336C16.292 8.54336 16.9247 7.63875 17.534 7.59112C18.1107 7.54604 18.8589 8.25355 18.8589 8.25355L17.8032 14.3603Z"
        fill="#EFC52E"
      />
      <path
        d="M16.9961 14.3603H17.7827L17.7032 14.6943C17.6893 14.7526 17.6357 14.7927 17.5758 14.7896L17.045 14.7616C16.9664 14.7575 16.9114 14.6821 16.9314 14.606L16.9961 14.3603Z"
        fill="#A48137"
      />
      <path
        d="M14.6568 9.70257L14.2842 9.26785C14.2842 9.26785 16.7809 6.71647 17.9068 7.75669C18.4594 8.26714 18.59 9.55766 18.59 9.55766L17.6584 10.0545C17.6584 10.0545 17.7539 10.4215 17.5963 10.4892C17.4229 10.5637 17.2651 10.1373 17.2651 10.1373L16.1059 10.1994C16.1059 10.1994 16.0319 10.5847 15.8574 10.572C15.6713 10.5585 15.7125 10.1166 15.7125 10.1166L14.9259 9.80608C14.9259 9.80608 14.8002 10.1533 14.6568 10.0959C14.5142 10.0387 14.6568 9.70257 14.6568 9.70257Z"
        fill="#A48137"
      />
      <path
        d="M19.7761 14.9876L19.8731 14.5674C19.8731 14.5674 19.5451 14.6243 19.3349 14.6088C19.1197 14.593 18.7967 14.4846 18.7967 14.4846L18.6731 14.8004C18.6388 14.8879 18.6842 14.9861 18.7743 15.0131C18.8904 15.0479 19.0466 15.09 19.1693 15.1056C19.3109 15.1237 19.5044 15.119 19.628 15.1131C19.7001 15.1096 19.7599 15.0579 19.7761 14.9876Z"
        fill="#A48137"
      />
      <path
        d="M9.37831 12.4353L9.0885 14.3812C9.0885 14.3812 8.78515 14.4993 8.59168 14.4847C8.42067 14.4718 8.15696 14.3191 8.15696 14.3191C8.15696 14.3191 8.39612 13.2632 8.32257 12.7044C8.32257 12.1869 8.35581 11.4824 8.32257 11.007C8.27685 10.3533 8.09486 9.80631 7.92925 9.5579C7.7248 9.25123 7.18933 8.84211 6.35598 8.46075C5.13463 7.90183 4.65764 7.13945 4.26519 5.9972C3.80304 4.65211 3.76835 3.51399 4.82411 2.56099C5.34264 2.09295 5.80824 2.08907 6.45949 1.83646C7.07206 1.59886 7.32401 1.31276 8.05345 1.29802C8.61952 1.28658 9.12736 1.51516 9.68883 1.58805C10.8122 1.7339 11.4546 1.6808 12.587 1.71226C14.8226 1.77436 18.8832 0.363467 20.7845 2.72676C22.2336 4.52788 21.0536 7.01209 20.3705 9.74444C19.8711 11.7419 19.853 14.6089 19.853 14.6089C19.853 14.6089 19.5243 14.6258 19.3147 14.6089C19.1107 14.5925 18.7972 14.5261 18.7972 14.5261C18.7972 14.5261 19.1005 13.6889 19.0042 12.3939C18.8619 10.48 18.2259 7.86042 17.5345 7.86042C17.1204 7.86042 15.964 9.2197 14.2637 9.28879C11.5105 9.47509 10.3539 7.94323 10.0821 8.60566C9.72976 9.4646 9.97452 9.75395 9.75093 10.655C9.57986 11.3444 9.37831 12.4353 9.37831 12.4353Z"
        fill="#FDFBEB"
      />
      <path
        d="M8.6952 5.58301C9.39575 4.88437 9.3371 5.3999 10.4755 4.73448C11.821 3.94795 12.0645 6.25702 13.4357 5.58301C14.6571 4.98269 15.7598 6.30369 15.837 7.01163C15.8901 7.49851 14.243 7.15642 14.1188 8.10866C13.9336 9.52912 11.6554 8.93674 11.6554 8.93674C11.6554 8.93674 10.3467 8.33641 10.1857 8.48132C9.97866 8.66763 9.81305 9.47496 9.81305 9.47496C9.81305 9.47496 8.5089 8.48132 8.8608 7.57044C9.14147 6.84394 8.05138 6.22509 8.6952 5.58301Z"
        fill="#EFC52E"
      />
      <path
        d="M5.15201 6.98002C5.75068 6.80462 5.33423 5.14338 5.83824 4.77576C6.3375 4.4116 6.93755 4.79551 7.49432 4.52742C8.7883 3.90435 10.6679 2.98004 9.48952 2.15899C8.34306 1.36014 7.98431 1.97284 7.10099 1.77428C6.30742 1.59589 6.65161 2.16338 5.83824 2.15899C4.46795 2.15159 4.04068 3.40911 4.14077 4.77576C4.20699 5.68004 4.28188 7.23495 5.15201 6.98002Z"
        fill="#EFC52E"
      />
      <path
        d="M21.4881 5.00343C21.2017 5.86241 20.1107 4.34397 19.2194 3.85513C18.5779 3.50332 18.8947 5.29523 17.3031 4.73649C14.9676 3.9166 15.4117 1.48328 15.4117 1.48328C15.4117 1.48328 18.6313 0.884143 20.2405 2.2009C21.289 3.05884 21.6744 4.44451 21.4881 5.00343Z"
        fill="#EFC52E"
      />
      <path
        d="M2.29853 5.10742C2.05012 4.42429 1.81021 2.4492 1.78101 2.4784C1.44972 2.80962 -0.206362 2.56079 0.0214294 1.83668C0.31661 0.898342 1.84898 1.67024 2.02933 1.56715C2.31906 1.40154 2.44335 0.555599 3.39567 0.53252C4.26503 0.511452 4.61695 1.29804 4.76193 1.40196C4.90549 1.50485 6.83171 1.18575 6.45941 2.06439C5.94188 3.28574 4.88614 2.60261 4.88614 2.60261C4.88614 2.60261 4.78264 4.21728 4.43072 5.19022C4.3475 5.42031 4.50152 5.63386 4.45142 5.87335C4.3435 6.38921 3.83988 6.5315 3.31287 6.53578C2.77903 6.54012 2.27992 6.40042 2.19502 5.87335C2.15137 5.60234 2.39234 5.3654 2.29853 5.10742Z"
        fill="#FDFBEB"
      />
      <path
        d="M3.16747 2.39536C2.8794 1.94161 2.49469 1.01195 2.17382 1.44312C2.13491 1.49541 2.09102 1.58803 2.09102 1.58803C2.09102 1.58803 1.72844 2.1137 1.78051 2.47816C1.88401 3.20269 2.14563 4.51302 2.14563 4.51302C2.14563 4.51302 2.3333 4.38988 2.48434 4.36195C2.79528 4.30443 2.92692 4.13248 3.16747 3.92723C3.34581 3.77505 3.49015 3.70843 3.58148 3.49251C3.75989 3.07074 3.41291 2.78198 3.16747 2.39536Z"
        fill="#EFC52E"
      />
      <path
        d="M2.50546 3.1633C2.50546 3.1633 2.5063 2.95539 2.71924 2.92566C2.93218 2.89593 2.99498 3.16796 2.99498 3.16796"
        stroke="#1C4321"
        strokeWidth="0.112789"
        strokeLinecap="round"
      />
      <path
        d="M3.78671 3.14768C3.78671 3.14768 3.78755 2.93977 4.00049 2.91004C4.21343 2.88031 4.27623 3.15234 4.27623 3.15234"
        stroke="#1C4321"
        strokeWidth="0.112789"
        strokeLinecap="round"
      />
      <path
        d="M3.29222 6.56362C4.03748 6.61137 4.65854 6.20265 4.4308 5.6538C4.20306 5.10496 3.76528 5.23601 3.29222 5.23133C2.87024 5.22715 2.41102 5.13293 2.25715 5.54827C1.96739 6.3304 2.67855 6.52431 3.29222 6.56362Z"
        fill="#B69BDE"
      />
      <circle cx="2.79569" cy="5.62467" r="0.0828036" fill="#1C4321" />
      <circle cx="3.87187" cy="5.62467" r="0.0828036" fill="#1C4321" />
    </SvgIcon>
  );
}
